export const GET_FEES_LIST = "FEES/fees_list";
export const GET_FEE = "FEES/fee";
export const ADD_FEE = "FEES/add_fee";
export const UPDATE_FEE = "FEES/update_fee";
export const DELETE_FEE = "FEES/delete_fee";